import { useCallback, useEffect } from "react";

export const resetBodyPointerEvents = () => {
  try {
    if (typeof document === "undefined") return;
    const { body } = document;
    if (!body) return;
    if (body.style.pointerEvents === "none") {
      body.style.pointerEvents = "";
    }
  } catch {
    // Ignore environments where document is not available.
  }
};

export const useResetBodyPointerEvents = (
  open: boolean | undefined,
  onOpenChange?: (open: boolean) => void
) => {
  useEffect(() => {
    if (open === false) {
      resetBodyPointerEvents();
    }

    return () => {
      resetBodyPointerEvents();
    };
  }, [open]);

  return useCallback(
    (isOpen: boolean) => {
      onOpenChange?.(isOpen);
      if (!isOpen) {
        resetBodyPointerEvents();
      }
    },
    [onOpenChange]
  );
};
